import { render, staticRenderFns } from "./view-video.vue?vue&type=template&id=6175643e"
import script from "./view-video.vue?vue&type=script&lang=js"
export * from "./view-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports